import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  messageSuppresed: {
    id: 'screens.HubScreen.components.Message.messageSuppresed',
    defaultMessage: 'Message suppressed for patient privacy',
  },
  fileUploading: {
    id: 'screens.HubScreen.components.Message.fileUploading',
    defaultMessage: 'File uploading...',
  },
  fileAttached: {
    id: 'screens.HubScreen.components.Message.fileAttached',
    defaultMessage: 'File attached',
  },
  viaLuma: {
    id: 'screens.HubScreen.components.Message.viaLuma',
    defaultMessage: 'via Luma',
  },
});
